// extracted by mini-css-extract-plugin
export default {"tutorialImage":"TutorialSlide_tutorialImage__IzQcF","outBtn":"TutorialSlide_outBtn__P73Ul"};